// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updatePartType = partType => ({
    partType,
    type: actions.UPDATE_CLAIM_PARTS_PART_TYPE
});



// WEBPACK FOOTER //
// ./src/claim/parts/action-creators/part-types.js